import { createAction, props } from '@ngrx/store';
import { Country } from '../Clubs/clubs.model';
import { Club, Member } from './member.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records member'
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records member success', 
    props<{ listData: Member[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records member failure', 
    props<{ error: string }>()
);

// fetch all address members
export const fetchAddressRecords = createAction(
    '[Data] fetch address records member',
    props<{ memberId: number }>()
);

export const fetchAddressRecordsSuccess = createAction(
    '[Data] fetch address records member success', 
    props<{ listData: Member[], total: number }>()
);

export const fetchAddressRecordsFail = createAction(
    '[Data] fetch address records member failure', 
    props<{ error: string }>()
);

//Fetch Club Speific Members
export const fetchSpecificData = createAction(
    '[Data] fetch specific records member',
    props<{ clubId: number }>()
);

export const fetchSpecificDataSuccess = createAction(
    '[Data] fetch specific records member success', 
    props<{ listData: Member[], total: number }>()
);

export const fetchSpecificDataFail = createAction(
    '[Data] fetch specific records member failure', 
    props<{ error: string }>()
);


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record member',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record member success', 
    props<{ singleData: Member, memberData: {countryList: Country[], clubs: Club[] }}>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record member failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record member',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record member success'
);
export const addRecordFailure = createAction(
    '[Data] Add record member failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record member',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record member success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record member failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record member',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record member success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record member failure',
    props<{ error: string }>()
);

// Delete Data
export const anonymizeRecord = createAction(
    '[Data] Anonymize record member',
    props<{ id: string }>()
);
export const anonymizeRecordSuccess = createAction(
    '[Data] Anonymize record member success'
);
export const anonymizeRecordFailure = createAction(
    '[Data] Anonymize record member failure',
    props<{ error: string }>()
);

// Import Records
export const importRecord = createAction(
    '[Data] Import record member',
    props<{ newData: any }>()
);
export const importRecordSuccess = createAction(
    '[Data] Import record member success'
);
export const importRecordFailure = createAction(
    '[Data] Import record member failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state member',
);